// Re-resolve shared/bookmarked URLs; never show collection/type or SKU expansion.
(async () => {
  if (window.Shopify?.designMode) return;
  const url = new URL(location.href), original = url.href, term = url.searchParams.get('q');
  if (!term || !window.BWRelatedSearch) return;
  const root = document.querySelector('.template-search');
  try {
    const match = await window.BWRelatedSearch.expand(term);
    if (url.searchParams.get('q') !== match.query) {
      url.searchParams.set('q',match.query);
      url.searchParams.delete('page'); url.searchParams.delete('bw_page');
    }
    url.searchParams.set('options[unavailable_products]','show');
    url.searchParams.set('type','product');
    if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by','relevance');
    if (url.href !== original) location.replace(url.href);
    else root?.removeAttribute('data-bw-search-pending');
  } catch (_) {
    if (root) {
      root.setAttribute('data-bw-search-pending','');
      window.BWRelatedSearch.showError(root.querySelector('.template-search__header') || root);
    }
  }
})();
